import React from "react";
import * as CHQ from "chq";

import { Trans } from "app/utils";
import NotificationBody from "./NotificationBody";

type VideoMontageErrorNotificationProps = {
  notification: CHQ.NotificationVideoMontageError;
  tabIndex?: number;
};

const VideoMontageErrorNotification: React.FC<VideoMontageErrorNotificationProps> = ({
  notification: { entity }
}) => (
  <NotificationBody actor={entity}>
    <Trans>
      Your video montage story failed, please try again or contact support to help you
    </Trans>
    <br />
  </NotificationBody>
);

export default VideoMontageErrorNotification;
